import { useEffect, useState } from 'react'
import cnames from 'classnames'
import { useLazyQuery } from 'Shared/Hooks/useApolloClient'
import campgroundQuery from 'Shared/Calendar/Queries/campgroundQuery'
import FontAwesomeIcon from 'Shared/FontAwesomeIcon/FontAwesomeIcon'

const SitesByTypeDropdown = ({ slug }) => {
  const [expandedTypes, setExpandedTypes] = useState({})
  const [isVisible, setIsVisible] = useState(false)
  const [loadCampground,
         { data, loading }] = useLazyQuery(campgroundQuery, { fetchPolicy: 'network-only', variables: { slug } })

  useEffect(() => {
    if (isVisible) loadCampground()
  }, [isVisible])

  const onKeyDown = e => {
    if (e.key === 'Enter' || e.key === ' ') toggleDropdown()
  }

  const onTypeKeyDown = (e, typeInfo) => {
    if (e.key === 'Enter' || e.key === ' ') toggleType(typeInfo.type)
  }

  const toggleDropdown = () => setIsVisible(prev => !prev)

  const toggleType = type => {
    setExpandedTypes(prev => ({
      ...prev,
      [type]: !prev[type],
    }))
  }

  const dropdownClasses = cnames('dropdown-menu-site-names text-start',
                                 { 'd-none': !isVisible, 'd-block': isVisible })
  const siteCategoryClasses = cnames('d-flex justify-content-between align-items-center site-category-header',
                                     'cursor-pointer')
  const sitesCount = data?.campground?.sitesCountByType.total ?? 0
  const sitesCountByType = data?.campground?.sitesCountByType.groups ?? []

  return (
    <>
      <div className="d-flex text-md align-items-center cursor-pointer" id="site-names-toggle"
           onClick={toggleDropdown} role="button" tabIndex={0} onKeyDown={onKeyDown}>
        <span className="flex-grow-1">
          <FontAwesomeIcon icon="campground" className="text-muted me-2" />

          Site Name
        </span>
      </div>

      <div className={dropdownClasses} id="site-names-dropdown">
        <div className="px-3 pt-3 pb-2 border-bottom">
          <p className="fw-bold text-lg mb-2">Site Categories</p>

          <p className="text-muted mb-2">Total: {sitesCount} sites</p>
        </div>

        {loading && <div className="px-3 py-2 text-muted">Loading sites...</div>}

        {!loading && sitesCountByType.map(typeInfo => (
          <div key={typeInfo.type} className="ps-3 pe-4 py-3 border-bottom">
            <div className="site-category">
              <div className={siteCategoryClasses} data-type={typeInfo.type}
                   onClick={() => toggleType(typeInfo.type)} onKeyDown={e => onTypeKeyDown(e, typeInfo)}
                   role="button" tabIndex={0}>
                <span>
                  <FontAwesomeIcon icon="circle" className={cnames('text-sm me-2', typeInfo.text_class)} />

                  {typeInfo.name}
                </span>

                <div className="mr-auto">
                  <span className="text-muted">{typeInfo.count}</span>

                  <FontAwesomeIcon className="ms-2 text-muted"
                                   icon={expandedTypes[typeInfo.type] ? 'chevron-up' : 'chevron-down'} />
                </div>
              </div>

              <div className={cnames('site-list mt-2 pl-2', { 'd-none': !expandedTypes[typeInfo.type] })}
                   id={`site-list-${typeInfo.type}`}>
                {typeInfo.sites.map(siteName => (
                  <p key={siteName} className="site-item fw-medium mb-0 ps-4 py-2">
                    {siteName}
                  </p>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  )
}

export default SitesByTypeDropdown
